import {
	ColorInputProps,
	ColorInput as NativeColorInput,
} from '@mantine/core';
import classes from './ColorInput.module.css';

const ColorInput = (props: ColorInputProps) => {
	return (
		<NativeColorInput classNames={classes} {...props} />
	);
};

export default ColorInput;
